"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFPStatus = exports.RFPStatusLabels = exports.RFPStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.RFPStatuses = ['OPEN', 'VOID', 'AWARD', 'SUBMITTED', 'LOST', 'DECLINED'];
exports.RFPStatusLabels = {
    OPEN: 'Open',
    VOID: 'Voided',
    AWARD: 'Awarded',
    SUBMITTED: 'Submitted',
    LOST: 'Lost',
    DECLINED: 'Declined',
};
exports.RFPStatus = typebox_1.Type.Union(exports.RFPStatuses.map((value) => typebox_1.Type.Literal(value)));
//# sourceMappingURL=rfp-common-types.js.map